<app-table [table]="rapidoEarningInfoTable"></app-table>
